import { useTranslation } from 'react-i18next';
import React from 'react';

import { Heading3, Subheading } from '../../../components/Typography';
import { FooterLink } from '../../../services/helpCenter';
import useTailorTracking from '../hooks/useTailorTracking';
import useLinks from '../hooks/useLinks';

export default function TailorLooking({ footerLink }: { footerLink?: FooterLink }) {
  const { captureFooterLinkClick } = useTailorTracking();
  const { openLink, getLinkTarget } = useLinks();
  const { t } = useTranslation();

  const onClickFooterLink = (event: React.MouseEvent) => {
    event.preventDefault();
    captureFooterLinkClick(footerLink);
    if (footerLink?.link) {
      openLink(footerLink.link, { action_type: footerLink?.action_type });
    }
  };

  if (!footerLink?.show) {
    return null;
  }

  return (
    <div
      data-testid="tailor-looking-container"
      className="bg-black px-8 py-6"
    >
      <Heading3 className="text-white">{footerLink.description || t('looking_for_something_else')}</Heading3>
      <Subheading className="text-stone-300">
        <span className="border-b border-stone-300">
          <img
            src={footerLink?.logo}
            className="w-3 mr-1 mb-1 inline text-stone-300"
          />
          <a
            onClick={onClickFooterLink}
            href={footerLink?.link}
            target={getLinkTarget(footerLink?.link)}
            rel="noreferrer"
          >
            {footerLink?.text}
          </a>
        </span>
      </Subheading>
    </div>
  );
}
